import {PagesStyle} from '@/Styles/pages.js';
import {Box, Link as MuiLink} from '@mui/material';
import {memo} from 'react';

const items = [
    {
        key: 'layout-footer-social-youtube',
        label: 'Logo Youtube',
        href: 'https://www.youtube.com/channel/UCZuyFawwILV67wn4l2PH6lA',
        image: '/images/icons/icon-youtube-colour.svg',
        style: {
            width: 30,
        },
    },
    {
        key: 'layout-footer-social-linkedin',
        label: 'Logo Linkedin',
        href: 'https://www.linkedin.com/authwall?trk=bf&trkInfo=AQEzaO35Fb-w1wAAAZK51ihoE7d6TgUb3zwu9vlzZmmZ7STcQq2QFdxCh1CCABchbwhCSuiU74trYHOZtWvtKs5AxaZ1UssT9ZEnd2LxcVLp2w9KYIYa5QIlBNSJkOvFlOCj9sc=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fmitsubishi-electric-europe-france%2F',
        image: '/images/icons/icon-linkedin-colour.svg',
        style: {
            width: 40,
        },
    },
    {
        key: 'layout-footer-social-instagram',
        label: 'Logo Instagram',
        href: 'https://www.instagram.com/mitsubishielectric_fr/',
        image: '/images/icons/icon-instagram-colour.svg',
        style: {
            width: 25,
        },
    },
];

const SocialMenu = () => {
    return (
        <Box component="nav" sx={navStyle}>
            <Box component="ul" sx={PagesStyle.list}>
                {items.map(({key, href, label, image, style}) => (
                    <Box key={key} component="li" sx={PagesStyle.list_item}>
                        <MuiLink href={href} color="inherit" underline="none" target="_blank">
                            <img css={{...iconStyle, ...style}} src={image} className="" alt={label} />
                        </MuiLink>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

const navStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
};
const iconStyle = {
    display: 'inline-block',
    width: '2.5rem',
    height: '2.5rem',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50%',
};

export default memo(SocialMenu);
